import { DialogActions, DialogActionsProps } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonColor } from '../../../../atomic/button';

type Props = {
  onCancel?: () => void;
  onConfirm?: () => void;
  confirmButtonText?: string;
  confirmButtonColor?: string;
  cancelButtonText?: string;
  confirmButtonDisabled?: boolean;
  actionsDisabled?: boolean;
} & DialogActionsProps;

export const InformationDialogFooter: FC<Props> = ({
  onCancel,
  onConfirm,
  confirmButtonText,
  confirmButtonColor,
  confirmButtonDisabled = false,
  actionsDisabled = false,
  cancelButtonText
}) => {
  const { t } = useTranslation('common');

  return (
    <DialogActions
      disableSpacing
      sx={{
        padding: '1.5rem',
        gap: '1rem',
        flexWrap: 'wrap'
      }}
    >
      {onCancel && (
        <Button variant="secondary" onClick={onCancel} disabled={actionsDisabled}>
          {cancelButtonText ?? t('CANCEL')}
        </Button>
      )}
      {onConfirm && (
        <Button
          color={(confirmButtonColor as ButtonColor) ?? 'midnight'}
          onClick={onConfirm}
          disabled={confirmButtonDisabled || actionsDisabled}
        >
          {confirmButtonText ?? t('CONFIRM')}
        </Button>
      )}
    </DialogActions>
  );
};
